/* Volcom-style product layout, using Cabane product data and shared local chrome. */

(() => {

  if (window.cabaneReferenceProduct) return;

  window.cabaneReferenceProduct = true;

  const ready = (async () => {

    const serviceVisual = document.querySelector('#nr-product-fallback .cabane-service-visual')?.outerHTML;
    let product = await window.CabaneProductContext.detail(document.querySelector('#local-product').dataset.handle);

    document.querySelector('#local-product').textContent=JSON.stringify(product);

    const esc = value => String(value ?? '').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

    const money = n => (n/100).toLocaleString('fr-FR',{style:'currency',currency:'EUR'});

    const image = url => new URL(url,location.origin).href;

    const loadScript = src => new Promise(resolve => { const s=document.createElement('script');s.src=src;s.onload=resolve;s.onerror=resolve;document.body.append(s); });

    if (!window.CabaneProductContext) await loadScript('//www.cabanedelaglisse.fr/cdn/shop/t/54/assets/nr-product-context.js?v=75889853126659072411792796472');

    const context=window.CabaneProductContext;

    if (!window.CabaneProductColors) await loadScript('//www.cabanedelaglisse.fr/cdn/shop/t/54/assets/nr-product-color-family.js?v=166786506425638346221792796356');

    const scooter=context.isScooter(product);

    document.body.classList.add('vp-template');

    const main=document.querySelector('main');main.id='MainContent';main.className='vp-product';

    let variants=product.variants;

    let variant=variants.find(v=>String(v.id)===new URL(location.href).searchParams.get('variant')) || variants.find(v=>v.available) || variants[0];

    let images=product.images.map(image);

    let hasOptions=variants.length>1 || product.options.some(o=>/taille|size|pointure|largeur|width/i.test(o.name));

    let colorIndex=product.options.findIndex(o=>/couleur|color/i.test(o.name));

    // A fixed colour already has its own heading: keep size buttons concise,

    // while retaining every varying option so different variants stay distinct.

    let pickerIndexes=product.options.map((_,i)=>i).filter(i=>i!==colorIndex || new Set(variants.map(v=>v.options[i])).size>1);

    let visibleIndexes=pickerIndexes.length ? pickerIndexes : product.options.map((_,i)=>i);

    const optionLabel=v=>visibleIndexes.map(i=>v.options[i]).join(' / ') || v.title;

    let pickerHeading=visibleIndexes.map(i=>product.options[i].name).join(' / ');

    const selectedColor=()=>window.CabaneProductColors.label(product,variant);

    const swatchColor=name=>window.CabaneProductColors.style(name,product);

    const productBreadcrumbs = main.querySelector(':scope > .cabane-breadcrumbs-bar');
    const initialSetup = main.querySelector('[data-setup-pilot]')?.outerHTML || '';
    // Keep the actual node: Notify Me binds its official manual button by ID.
    const initialRestock = main.querySelector('[data-cabane-restock]');

    main.innerHTML=`<div class="vp-layout"><section class="vp-media" aria-label="Photos de ${esc(product.title)}"><div class="vp-gallery" tabindex="0" aria-label="Galerie produit">${images.map((src,i)=>`<button class="vp-photo" type="button" aria-label="Agrandir la photo ${i+1}" data-photo="${i}"><img src="${esc(src)}" alt="${esc(product.title)} — vue ${i+1}" loading="${i<2?'eager':'lazy'}" width="1000" height="1250"></button>`).join('')}</div><div class="vp-gallery-controls" aria-label="Faire défiler les photos"><button type="button" data-gallery-step="-1" aria-label="Photo précédente" disabled><svg viewBox="0 0 26 24" aria-hidden="true"><path d="M22 12H4m7-7-7 7 7 7"/></svg></button><button type="button" data-gallery-step="1" aria-label="Photo suivante"><svg viewBox="0 0 26 24" aria-hidden="true"><path d="M4 12h18m-7-7 7 7-7 7"/></svg></button></div><nav class="vp-thumbnails" aria-label="Choisir une photo du produit"></nav></section>

      <article class="vp-buy"><h1>${esc(product.title)}</h1><div class="vp-price-row"><strong class="vp-price"></strong><s hidden></s></div><p class="vp-tax">Taxes incluses. France : livraison Mondial Relay à partir de 4 €, Colissimo à domicile 7 €. Livraison offerte dès 90 € d’achat.</p>

      <div class="vp-option-heading"><p><b>${selectedColor()?'COULEUR':'MARQUE'}</b> — <span class="vp-color-name">${esc(selectedColor()||product.vendor)}</span></p><span class="vp-sku"></span></div><nav class="vp-swatches" aria-label="Coloris disponibles" ${colorIndex>=0?'':'hidden'}><a href="/products/${esc(product.handle)}" aria-label="${esc(selectedColor()||product.title)}" aria-current="page" style="--swatch:${swatchColor(selectedColor())}"></a></nav>

      <fieldset class="vp-options" ${hasOptions?'':'hidden'}><legend>${esc(pickerHeading)}${context.classify(product).discipline==='skate'?'':' - <span class="vp-selected"></span>'}</legend>${variants.map(v=>`<label title="${esc(v.title)}${v.available?'':' — Indisponible'}"><input type="radio" name="vp-variant" value="${v.id}" aria-label="${esc(optionLabel(v))}${v.available?'':' — Indisponible'}" ${v.id===variant.id?'checked':''} ${v.available?'':'disabled'}><span>${esc(optionLabel(v))}</span></label>`).join('')}</fieldset>

      ${initialSetup}<div class="vp-purchase"><button class="vp-add" type="button">AJOUTER AU PANIER</button><p class="vp-availability" role="status"></p></div>

      <div class="vp-details"><details><summary>DESCRIPTION<span aria-hidden="true"></span></summary><div class="vp-detail-body">${product.description||'<p>Contacte le shop pour plus d’informations sur ce produit.</p>'}</div></details>

      

      

      </div></article></div><section class="vp-recommendations" hidden><h2>VOUS AIMERIEZ AUSSI</h2><div class="vp-product-rail"></div></section>`;

    if (productBreadcrumbs) main.prepend(productBreadcrumbs);
    if (initialRestock) main.querySelector('.vp-purchase').after(initialRestock);

    if(images.length<2)main.querySelector('.vp-gallery-controls').hidden=true;

    if(!images.length)main.querySelector('.vp-gallery').innerHTML=serviceVisual || '<div class="vp-photo-placeholder">Photo à venir</div>';

    let colorPicker;
    let purchasePending = false;

    const update=()=>{
      if (initialRestock) initialRestock.hidden = product.handle !== initialRestock.dataset.productHandle || variant.available;

      main.querySelector('.vp-price').textContent=money(variant.price);

      const old=main.querySelector('.vp-price-row s');old.hidden=!(variant.compare_at_price>variant.price);old.textContent=money(variant.compare_at_price||0);

      main.querySelector('.vp-sku').textContent=variant.sku?'Réf. '+variant.sku:'';

      const selectedOption=main.querySelector('.vp-selected');

      if(selectedOption)selectedOption.textContent=optionLabel(variant);

      main.querySelector('.vp-color-name').textContent=selectedColor()||product.vendor;

      colorPicker?.sync();

      main.querySelector('.vp-add').disabled=!variant.available || purchasePending;

      main.querySelector('.vp-add').textContent=purchasePending?'AJOUT EN COURS…':variant.available?'AJOUTER AU PANIER':'ÉPUISÉ';

      main.querySelector('.vp-availability').textContent=variant.available?'Retrait gratuit à la boutique de Lille':'Cette version est actuellement indisponible.';

      if(variant.featured_image&&main.querySelector('.vp-photo img')){main.querySelector('.vp-photo img').src=image(variant.featured_image.src);images[0]=image(variant.featured_image.src);const thumb=main.querySelector('.vp-thumbnails img');if(thumb)thumb.src=images[0];}

    };

    update();





    await loadScript('//www.cabanedelaglisse.fr/cdn/shop/t/54/assets/nr-product-design-extras.js?v=153849946494114705471793006061');

    await window.CabaneProductDesignExtras;

    // Read the merchant-owned sheet for the selected product AND variant.

    // HTML fallback is rendered by Liquid with the same selected variant.

    const technicalSources = new Map();

    const normSpec = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[_’']/g,' ').replace(/\s+/g,' ').trim();

    function sheetRows(sheet, selected) {

      const values = new Map();

      const keyFor = label => {

        const key = normSpec(label);

        if (/^(poids|poids total|poids annonce|weight|total weight)$/.test(key)) return 'weight';

        if (/^hauteur (totale|total|de la trottinette)$/.test(key)) return 'total-height';

        if (/^hauteur (du )?guidon( seul)?$/.test(key)) return 'bar-height';

        if (/^largeur (du )?guidon$/.test(key)) return 'bar-width';

        if (/^longueur (du )?deck$/.test(key)) return 'deck-length';

        if (/^largeur (du )?deck$/.test(key)) return 'deck-width';

        if (/^diametre (des? |de la )?roues?$/.test(key)) return 'wheel-diameter';

        if (/^matiere (du )?guidon$/.test(key)) return 'bar-material';

        return key;

      };

      const add = (items, group = '') => {

        for (const item of items || []) {

          if (!item || item.variant_id != null && String(item.variant_id).split('/').pop() !== String(selected.id)) continue;

          if (Array.isArray(item.variant_ids) && !item.variant_ids.some(id => String(id).split('/').pop() === String(selected.id))) continue;

          let label = item.label || item.key;

          if (/^(matiere|materiau)$/i.test(normSpec(label)) && group) label += ' — ' + group;

          let value = item.value;

          if (value && typeof value === 'object') value = value.value == null ? '' : value.value + (value.unit ? ' ' + value.unit : '');

          if (!label || value == null || String(value).trim() === '') continue;

          if (item.unit) value += ' ' + item.unit;

          values.set(keyFor(label), [label, String(value)]);

        }

      };

      const consume = entry => {

        add(entry.highlights); add(entry.items);

        for (const group of entry.groups || []) add(group.items, group.title);

      };

      consume(sheet);

      if (Array.isArray(sheet.variants)) {

        for (const entry of sheet.variants) if (String(entry.variant_id ?? entry.id).split('/').pop() === String(selected.id)) consume(entry);

      } else if (sheet.variants) {

        const entry = sheet.variants[String(selected.id)] || sheet.variants['gid://shopify/ProductVariant/' + selected.id];

        if (entry) {

          // Legacy Native sheets store these dimensions in millimetres.

          const fields = {deck_length:['Longueur du deck','mm'],deck_width:['Largeur du deck','mm'],bar_height:['Hauteur du guidon seul','mm'],bar_width:['Largeur du guidon','mm'],hauteur_totale:['Hauteur totale','mm'],roues_diametre:['Diamètre des roues','mm'],guidon_matiere:['Matière du guidon',''],frein:['Frein','']};

          add(Object.entries(fields).filter(([key]) => entry[key] != null).map(([key,[label,unit]]) => ({label,value:entry[key],unit})));

        }

      }

      return [...values.values()];

    }

    async function renderTechnical(target, selected = variant) {

      const key = target.handle + ':' + selected.id;

      if (!technicalSources.has(key)) {

        const request = fetch('/products/' + encodeURIComponent(target.handle) + '?view=nr-specs&variant=' + encodeURIComponent(selected.id))

          .then(response => {if (!response.ok) throw Error('Fiche technique indisponible'); return response.text();})

          .catch(error => {technicalSources.delete(key); throw error;});

        technicalSources.set(key, request);

      }

      const doc = new DOMParser().parseFromString(await technicalSources.get(key), 'text/html');

      const data = doc.querySelector('cabane-spec-sheet script[type="application/json"]');

      const catalogNode = doc.querySelector('[data-cabane-catalog-sections]');

      const catalog = catalogNode ? JSON.parse(catalogNode.textContent) : null;

      let rows;

      if (catalog && Array.isArray(catalog.rows)) rows = catalog.rows;

      else if (data && context.isScooter(target)) {

        const payload = JSON.parse(data.textContent);

        if (payload.technical_sheet?.groups?.length) rows = sheetRows(payload.technical_sheet, selected);

        else {

          if (!window.CabaneTechProfiles) await loadScript('//www.cabanedelaglisse.fr/cdn/shop/t/54/assets/cabane-tech-profiles.js?v=137684631531793857691792796181');

          rows = window.CabaneTechProfiles?.rows(payload, selected)?.map(row => [row.label,row.value]);

        }

      } else rows = [...doc.querySelectorAll('dt')].map(node => [node.textContent.trim(),node.nextElementSibling?.textContent.trim()]);

      // Ignore late responses after another size or colour has been selected.

      if (product !== target || String(variant.id) !== String(selected.id)) return;

      if (catalog && typeof catalog.description === 'string') {

        main.querySelector('.vp-details details:not(.vp-technical) .vp-detail-body').innerHTML = window.CabaneAuditCopy?.description(target.handle, catalog.description) || catalog.description;

      }

      const oldDetails = main.querySelector('.vp-technical');

      const wasOpen = oldDetails?.open || false;

      oldDetails?.remove();

      rows = (rows || []).filter(([label,value]) => label && value);

      // Drop generic option rows only when the same dimension is already explicit.

      const dimensionValue = value => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/,/g,'.').replace(/[’′″"']/g,'').replace(/\s+/g,'');

      rows = rows.filter(([label,value]) => !/^(taille|style)$/i.test(label) || !rows.some(([other,otherValue]) => /^(longueur|largeur) (de la planche|du deck)$/i.test(other) && dimensionValue(value) === dimensionValue(otherValue)));

      const technicalNotes = (catalog?.notes || []).filter(note => typeof note === 'string' && note.trim());

      if (rows.length || context.isScooter(target)) {

        const details = document.createElement('details'); details.className = 'vp-technical'; details.open = wasOpen;

        details.dataset.variant = selected.id;

        details.innerHTML = '<summary>FICHE TECHNIQUE<span aria-hidden="true"></span></summary><div class="vp-detail-body">' + (rows.length ? '<dl class="vp-spec-table">' + rows.map(([label,value]) => `<div><dt>${esc(label)}</dt><dd>${esc(value)}</dd></div>`).join('') + '</dl>' : '<p>Les caractéristiques détaillées de cette version ne sont pas encore renseignées. <a href="/pages/contact">Demande conseil au shop</a>.</p>') + (technicalNotes.length ? '<ul class="vp-spec-notes">' + technicalNotes.map(note => '<li>' + esc(note) + '</li>').join('') + '</ul>' : '') + '</div>';

        main.querySelector('.vp-details details').after(details);

      }

      window.CabaneRideProfile?.(target);

    }

    const technicalReady=renderTechnical(product).catch(error=>console.warn('Technical specifications unavailable',error));

    window.CabaneRender?.track(technicalReady);

    main.querySelector('.vp-options').addEventListener('change',event=>{const r=event.target;if(!r.matches('[name="vp-variant"]'))return;variant=variants.find(v=>String(v.id)===r.value);update();const u=new URL(location.href);u.searchParams.set('variant',variant.id);history.replaceState(null,'',u);main.querySelector('.vp-technical')?.remove();main.querySelector('.ride-profile')?.remove();renderTechnical(product,variant).catch(error=>console.warn('Technical specifications unavailable',error));});

    const primaryAdd = main.querySelector('.vp-add');
    const primaryStatus = main.querySelector('.vp-availability');
    const stickyPurchase = document.createElement('div');
    stickyPurchase.className = 'vp-sticky-purchase cabane-product-sticky';
    stickyPurchase.hidden = true;
    stickyPurchase.setAttribute('role', 'region');
    stickyPurchase.setAttribute('aria-label', 'Ajouter ce produit au panier');
    stickyPurchase.innerHTML = `<div class="cabane-product-sticky__inner">
      <img class="cabane-product-sticky__image" alt="" width="56" height="56">
      <div class="cabane-product-sticky__product"><span class="cabane-product-sticky__title"></span><span class="cabane-product-sticky__variant"></span></div>
      <div class="cabane-product-sticky__amount"><span class="cabane-product-sticky__price-label" hidden>Total</span><strong class="vp-sticky-purchase__price"></strong></div>
      <button type="button" class="vp-sticky-purchase__add">AJOUTER AU PANIER</button>
      <p class="cabane-product-sticky__status" role="status" hidden></p>
    </div>`;
    document.body.append(stickyPurchase);
    const stickyAdd = stickyPurchase.querySelector('button');
    const stickyPrice = stickyPurchase.querySelector('.vp-sticky-purchase__price');
    const stickyPriceLabel = stickyPurchase.querySelector('.cabane-product-sticky__price-label');
    const stickyTitle = stickyPurchase.querySelector('.cabane-product-sticky__title');
    const stickyVariant = stickyPurchase.querySelector('.cabane-product-sticky__variant');
    const stickyImage = stickyPurchase.querySelector('img');
    const stickyStatus = stickyPurchase.querySelector('.cabane-product-sticky__status');
    const setStickyText = (node, value) => { if (node.textContent !== value) node.textContent = value; };
    const modalIsVisible = () => Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"], cart-drawer.active, details[open] .menu-drawer')).some(node => {
      if (node.closest('[hidden], [aria-hidden="true"]')) return false;
      const style = getComputedStyle(node), rect = node.getBoundingClientRect();
      return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0 && rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth;
    });
    const syncStickyPurchase = () => {
      const selection = window.CabaneProductSetup?.getSelection?.() || { count: 0, total: 0 };
      const accessoryCount = Number(selection.count) || 0;
      const busy = primaryAdd.getAttribute('aria-busy') === 'true' || (primaryAdd.disabled && variant.available);
      const buttonLabel = busy ? 'AJOUT EN COURS…' : primaryAdd.textContent.trim();
      if (stickyAdd.disabled !== primaryAdd.disabled) stickyAdd.disabled = primaryAdd.disabled;
      if (stickyAdd.getAttribute('aria-busy') !== String(busy)) stickyAdd.setAttribute('aria-busy', String(busy));
      setStickyText(stickyAdd, buttonLabel);
      setStickyText(stickyTitle, product.title);
      const optionText = variant.title && !/^default title$/i.test(variant.title) ? variant.title : '';
      const accessoryText = accessoryCount ? `+ ${accessoryCount} accessoire${accessoryCount > 1 ? 's' : ''}` : '';
      setStickyText(stickyVariant, [optionText, accessoryText].filter(Boolean).join(' · '));
      if (stickyVariant.hidden !== !stickyVariant.textContent) stickyVariant.hidden = !stickyVariant.textContent;
      setStickyText(stickyPrice, money(Number(variant.price) + (Number(selection.total) || 0)));
      if (stickyPriceLabel.hidden !== !accessoryCount) stickyPriceLabel.hidden = !accessoryCount;
      const photo = variant.featured_image?.src || product.featured_image?.src || product.featured_image || product.images?.[0];
      if (photo && stickyImage.getAttribute('src') !== image(photo)) stickyImage.src = image(photo);
      if (stickyImage.hidden !== !photo) stickyImage.hidden = !photo;
      const statusText = primaryStatus.textContent.trim();
      const errorText = statusText && !/^(Retrait gratuit|Cette version est actuellement indisponible\.)/i.test(statusText) ? statusText : '';
      setStickyText(stickyStatus, errorText);
      if (stickyStatus.hidden !== !errorText) stickyStatus.hidden = !errorText;
      const visible = primaryAdd.getBoundingClientRect().bottom <= 0 && !modalIsVisible();
      if (stickyPurchase.hidden === visible) stickyPurchase.hidden = !visible;
      if (document.body.classList.contains('cabane-sticky-purchase-visible') !== visible) document.body.classList.toggle('cabane-sticky-purchase-visible', visible);
      const space = visible ? `${Math.ceil(stickyPurchase.getBoundingClientRect().height)}px` : '0px';
      if (document.body.style.getPropertyValue('--cabane-sticky-purchase-height') !== space) document.body.style.setProperty('--cabane-sticky-purchase-height', space);
    };
    let stickyScrollFrame = 0;
    const scheduleStickyPurchase = () => {
      if (stickyScrollFrame) return;
      stickyScrollFrame = requestAnimationFrame(() => { stickyScrollFrame = 0; syncStickyPurchase(); });
    };
    stickyAdd.addEventListener('click', () => {
      if (!primaryAdd.disabled) primaryAdd.click();
      syncStickyPurchase();
    });
    const stickyStateObserver = new MutationObserver(scheduleStickyPurchase);
    stickyStateObserver.observe(main.querySelector('.vp-buy'), { attributes: true, attributeFilter: ['disabled', 'aria-busy'], childList: true, subtree: true, characterData: true });
    const stickyVisibilityObserver = new IntersectionObserver(scheduleStickyPurchase, { threshold: [0, 1] });
    stickyVisibilityObserver.observe(primaryAdd);
    const stickyModalObserver = new MutationObserver(records => {
      if (records.some(record => !stickyPurchase.contains(record.target) && (record.type === 'childList' || record.target.matches?.('body, html, dialog, [aria-modal], cart-drawer, details, .lcg-wishlist, .lcg-search')))) scheduleStickyPurchase();
    });
    stickyModalObserver.observe(document.body, { attributes: true, attributeFilter: ['class', 'open', 'aria-hidden', 'style'], childList: true, subtree: true });
    if ('ResizeObserver' in window) {
      const stickySizeObserver = new ResizeObserver(scheduleStickyPurchase);
      stickySizeObserver.observe(primaryAdd);
      stickySizeObserver.observe(stickyPurchase);
    }
    window.addEventListener('scroll', scheduleStickyPurchase, { passive: true });
    window.addEventListener('resize', scheduleStickyPurchase, { passive: true });
    window.visualViewport?.addEventListener('resize', scheduleStickyPurchase, { passive: true });
    window.addEventListener('pageshow', scheduleStickyPurchase);
    document.addEventListener('cabane:product-change', scheduleStickyPurchase);
    document.addEventListener('cabane:setup-change', scheduleStickyPurchase);
    document.addEventListener('close', scheduleStickyPurchase, true);
    document.addEventListener('toggle', scheduleStickyPurchase, true);
    syncStickyPurchase();
    main.querySelector('.vp-add').addEventListener('click', async () => {
      const button = main.querySelector('.vp-add');
      if (!variant.available || button.disabled || purchasePending) return;
      purchasePending = true;
      button.setAttribute('aria-busy','true');
      update();
      let errorMessage = '';
      try {
        const item = {id:variant.id, quantity:1};
        if (window.CabaneProductSetup?.addToCart) await window.CabaneProductSetup.addToCart(item);
        else await window.CabaneLocal.addItem(item);
      } catch (error) {
        errorMessage = error.message || 'L’ajout a échoué. Réessaie dans un instant.';
      } finally {
        purchasePending = false;
        button.removeAttribute('aria-busy');
        update();
        if (errorMessage) main.querySelector('.vp-availability').textContent = errorMessage;
      }
    });

    const gallery=main.querySelector('.vp-gallery');

    const galleryControls=main.querySelector('.vp-gallery-controls');

    const galleryPrev=galleryControls.querySelector('[data-gallery-step="-1"]');

    const galleryNext=galleryControls.querySelector('[data-gallery-step="1"]');

    const thumbnails=main.querySelector('.vp-thumbnails');

    const renderThumbnails=()=>{

      thumbnails.hidden=images.length<2;

      thumbnails.innerHTML=images.map((src,i)=>{

        const small=new URL(src);small.searchParams.set('width','160');

        return `<button type="button" data-gallery-photo="${i}" aria-label="Voir la photo ${i+1}" aria-current="${i===0?'true':'false'}"><img src="${esc(small.href)}" alt="" width="56" height="66" loading="lazy"></button>`;

      }).join('');

    };

    renderThumbnails();

    thumbnails.addEventListener('click',event=>{

      const button=event.target.closest('[data-gallery-photo]');if(!button)return;

      const index=Number(button.dataset.galleryPhoto);

      if(matchMedia('(max-width:1023px)').matches)gallery.scrollTo({left:gallery.clientWidth*index,behavior:motion()});

      else gallery.querySelectorAll('.vp-photo')[index]?.scrollIntoView({behavior:motion(),block:'center'});

      thumbnails.querySelectorAll('button').forEach((item,i)=>item.setAttribute('aria-current',String(i===index)));

    });

    const motion=()=>matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth';

    const updateGalleryControls=()=>{

      const index=Math.round(gallery.scrollLeft/Math.max(gallery.clientWidth,1));

      galleryControls.hidden=images.length<2;

      if(matchMedia('(max-width:1023px)').matches)thumbnails.querySelectorAll('button').forEach((button,i)=>button.setAttribute('aria-current',String(i===index)));

      galleryPrev.disabled=index<=0;galleryNext.disabled=index>=images.length-1;

    };

    galleryControls.addEventListener('click',event=>{

      const button=event.target.closest('[data-gallery-step]');

      if(!button||button.disabled)return;

      gallery.scrollBy({left:gallery.clientWidth*Number(button.dataset.galleryStep),behavior:motion()});

    });

    gallery.addEventListener('scroll',updateGalleryControls,{passive:true});

    window.addEventListener('resize',updateGalleryControls);

    updateGalleryControls();

    gallery.addEventListener('keydown',e=>{if(e.target!==gallery||!['ArrowLeft','ArrowRight'].includes(e.key))return;e.preventDefault();gallery.scrollBy({left:gallery.clientWidth*(e.key==='ArrowLeft'?-1:1),behavior:motion()});});

    const zoom=document.createElement('dialog');zoom.className='vp-zoom';zoom.setAttribute('aria-label','Photo agrandie');

    zoom.innerHTML='<button class="vp-zoom-close" aria-label="Fermer la photo">×</button><div class="vp-zoom-stage"><img alt=""></div><img class="vp-zoom-preview" alt="Vue d’ensemble"><button class="vp-zoom-prev" aria-label="Photo précédente">←</button><button class="vp-zoom-next" aria-label="Photo suivante">→</button><span class="vp-zoom-count"></span>';

    document.body.append(zoom);let photoIndex=0,photoTrigger;

    const zoomImg=zoom.querySelector('.vp-zoom-stage img');

    const showImage=i=>{photoIndex=(i+images.length)%images.length;zoomImg.src=images[photoIndex];zoomImg.alt=product.title+' — vue '+(photoIndex+1);zoom.querySelector('.vp-zoom-preview').src=images[photoIndex];zoom.querySelector('.vp-zoom-count').textContent=`${photoIndex+1} / ${images.length}`;zoomImg.style.transformOrigin='50% 50%';};

    gallery.addEventListener('click',event=>{const b=event.target.closest('[data-photo]');if(!b)return;photoTrigger=b;showImage(Number(b.dataset.photo));zoom.showModal();document.body.classList.add('vp-zoom-open');});

    zoom.querySelector('.vp-zoom-close').onclick=()=>zoom.close();

    zoom.querySelector('.vp-zoom-prev').onclick=()=>showImage(photoIndex-1);zoom.querySelector('.vp-zoom-next').onclick=()=>showImage(photoIndex+1);

    zoom.addEventListener('keydown',e=>{if(e.key==='ArrowRight')showImage(photoIndex+1);if(e.key==='ArrowLeft')showImage(photoIndex-1);});

    zoom.addEventListener('close',()=>{document.body.classList.remove('vp-zoom-open');photoTrigger?.focus({preventScroll:true});});

    zoom.addEventListener('click',e=>{if(e.target===zoom){const r=zoom.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)zoom.close();}});

    zoom.querySelector('.vp-zoom-stage').addEventListener('pointermove',e=>{if(e.pointerType==='touch')return;const r=e.currentTarget.getBoundingClientRect();zoomImg.style.transformOrigin=`${(e.clientX-r.left)/r.width*100}% ${(e.clientY-r.top)/r.height*100}%`;});

    zoom.querySelector('.vp-zoom-stage').addEventListener('click',()=>zoom.classList.toggle('vp-zoom-fit'));

    // Colour siblings are separate catalogue products, but update the same buy box.

    // Keep the surrounding page, scroll position and ordered swatches mounted.

    function changeColor(next,nextVariant,pushHistory){
      if (!nextVariant.available && next.handle !== product.handle) {
        window.location.assign('/products/'+encodeURIComponent(next.handle)+'?variant='+encodeURIComponent(nextVariant.id));
        return;
      }

      const scroll=window.scrollY;

      product=next;variant=nextVariant;variants=product.variants;

      images=product.images.map(image);

      colorIndex=product.options.findIndex(o=>/couleur|color/i.test(o.name));

      hasOptions=variants.length>1||product.options.some(o=>/taille|size|pointure|largeur|width/i.test(o.name));

      pickerIndexes=product.options.map((_,i)=>i).filter(i=>i!==colorIndex||new Set(variants.map(v=>v.options[i])).size>1);

      visibleIndexes=pickerIndexes.length?pickerIndexes:product.options.map((_,i)=>i);

      pickerHeading=visibleIndexes.map(i=>product.options[i].name).join(' / ');

      document.querySelector('#local-product').textContent=JSON.stringify(product);

      document.title=product.title+' | La Cabane';

      const url='/products/'+encodeURIComponent(product.handle)+'?variant='+encodeURIComponent(variant.id);

      if(pushHistory)history.pushState(null,'',url);

      document.querySelector('link[rel="canonical"]')?.setAttribute('href',location.origin+url.split('?')[0]);

      main.querySelector('h1').textContent=product.title;

      const breadcrumbTitle=main.querySelector('.cabane-breadcrumbs [aria-current="page"]');

      if(breadcrumbTitle){breadcrumbTitle.textContent=product.title;breadcrumbTitle.title=product.title;}

      main.querySelector('.vp-option-heading b').textContent=selectedColor()?'COULEUR':'MARQUE';

      main.querySelector('.vp-media').setAttribute('aria-label','Photos de '+product.title);

      gallery.innerHTML=images.length?images.map((src,i)=>`<button class="vp-photo" type="button" aria-label="Agrandir la photo ${i+1}" data-photo="${i}"><img src="${esc(src)}" alt="${esc(product.title)} — vue ${i+1}" loading="${i<2?'eager':'lazy'}" width="1000" height="1250"></button>`).join(''):'<div class="vp-photo-placeholder">Photo à venir</div>';

      renderThumbnails();

      gallery.scrollLeft=0;

      updateGalleryControls();photoIndex=0;

      const options=main.querySelector('.vp-options');options.hidden=!hasOptions;

      options.innerHTML=`<legend>${esc(pickerHeading)}${context.classify(product).discipline==='skate'?'':' - <span class="vp-selected"></span>'}</legend>`+variants.map(v=>`<label title="${esc(v.title)}${v.available?'':' — Indisponible'}"><input type="radio" name="vp-variant" value="${v.id}" aria-label="${esc(optionLabel(v))}${v.available?'':' — Indisponible'}" ${v.id===variant.id?'checked':''} ${v.available?'':'disabled'}><span>${esc(optionLabel(v))}</span></label>`).join('');

      main.querySelector('.vp-details details .vp-detail-body').innerHTML=product.description||'<p>Contacte le shop pour plus d’informations sur ce produit.</p>';

      main.querySelector('.vp-technical')?.remove();main.querySelector('.ride-profile')?.remove();

      update();

      // Old asynchronous responses must never overwrite the newly selected product.

      renderTechnical(next,nextVariant).catch(error=>console.warn('Technical specifications unavailable',error));

      window.scrollTo({top:scroll,behavior:'instant'});

      document.dispatchEvent(new CustomEvent('cabane:product-change',{detail:{product,variant}}));

    }

    colorPicker=window.CabaneProductColors.mount({product,nav:main.querySelector('.vp-swatches'),getVariant:()=>variant,getProduct:()=>product,catalogue:context.catalogue,onSelect:changeColor});

    window.CabaneRender?.track(colorPicker.ready);

    // Illustrated facts use only this product's loaded technical specifications.

    await technicalReady;

    await loadScript('//www.cabanedelaglisse.fr/cdn/shop/t/54/assets/nr-product-ride-profile.js?v=175898618960063989771792796472');

    window.CabaneRideProfile?.(product);

    let recommendationsStarted=false;

    const startRecommendations=async()=>{

      if(recommendationsStarted)return;recommendationsStarted=true;

    await loadScript('//www.cabanedelaglisse.fr/cdn/shop/t/54/assets/nr-product-recommendation-cards.js?v=160454555498418959201792796472');

    await loadScript('//www.cabanedelaglisse.fr/cdn/shop/t/54/assets/nr-product-setup.js?v=52522071440417671801793130917');

    const setupReady=window.CabaneProductSetup(product).catch(error=>console.warn('Setup accessories unavailable',error));



    // Alternatives share the exact product family; complements use separate rules.

    const relatedReady=(async()=>{

      const catalogue=await context.catalogue();

      const products=await context.hydrate(context.alternatives(product,catalogue));

      const section=main.querySelector(':scope > .vp-recommendations');

      if(products.length){section.hidden=false;await window.CabaneRecommendationCards(section,products);}

    })().catch(error=>console.warn('Related products unavailable',error));



      await Promise.all([setupReady,relatedReady]);

    };

    const recommendationTrigger=main.querySelector('.vp-purchase');

    if('IntersectionObserver' in window && recommendationTrigger){

      const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){observer.disconnect();startRecommendations().catch(e=>console.warn('Recommendations unavailable',e));}},{rootMargin:'600px'});

      observer.observe(recommendationTrigger);

    }else startRecommendations().catch(e=>console.warn('Recommendations unavailable',e));





  })();

  window.CabaneRender?.track(ready);

  ready.catch(error=>{console.error('Reference product:',error);document.body.classList.add('vp-render-error');document.querySelector('#nr-product-fallback')?.removeAttribute('hidden');});

})();












